import React from 'react';
import Image, { ImageLoaderProps, ImageProps } from 'next/image';
import { environment } from '@environment';

export const imageLoader = ({ src }: ImageLoaderProps) => {
	if (src.startsWith('http')) {
		return src;
	}

	return `${environment.web_cdn_url}web/assets/img/${src}`;
};

const AnghamiImage = (props: ImageProps) => {
	return <Image {...props} unoptimized loader={imageLoader} />;
};

export default AnghamiImage;
